import React from 'react';
import { Card, Row, Col, CardBody } from 'reactstrap';
import ReactTable from 'react-table';
import Strings from '../../../../translations/Translations';

const tableColumns = [
  {
    Header: Strings('video'),
    accessor: 'rti',
    width: 250
  },
  {
    Header: Strings('views'),
    accessor: 'rhits'
  },
  {
    Header: Strings('likes'),
    accessor: 'rlikes'
  },
  {
    Header: Strings('photos'),
    accessor: 'rpn'
  },
  {
    Header: Strings('Users'),
    accessor: 'riun'
  } 
];

export default function AnalyzeGeneral(props) {
  const { totals, its } = props;

  return (
    <CardBody>
      <Row>
        <Col sm="3">

          <Card>
            <div className="widget-chart widget-chart-hover">
              <div className="icon-wrapper rounded-circle">
                <div className="icon-wrapper-bg bg-success" />
                <i className="lnr-eye text-success" />
              </div>
              <div className="widget-numbers">
                {totals && totals.rhits}
              </div>
              <div className="widget-subheading">
                {Strings('total_views')}
              </div>
            </div>
          </Card>
        </Col>

        <Col sm="3">
          <Card>
            <div className="widget-chart widget-chart-hover">
              <div className="icon-wrapper rounded-circle">
                <div className="icon-wrapper-bg bg-info" />
                <i className="lnr-thumbs-up text-info" />
              </div>
              <div className="widget-numbers">
                {totals && totals.rlikes}
              </div>
              <div className="widget-subheading">
                {Strings('total_likes')}
              </div>
            </div>
          </Card>
        </Col>

        <Col sm="3">
          <Card>
            <div className="widget-chart widget-chart-hover">
              <div className="icon-wrapper rounded-circle">
                <div className="icon-wrapper-bg bg-danger" />
                <i className="lnr-picture text-danger" />
              </div>
              <div className="widget-numbers">
                {totals && totals.rpn}
              </div>
              <div className="widget-subheading">
                {Strings('total_photos')}
              </div>
            </div>
          </Card>
        </Col>

        <Col sm="3">
          <Card>
            <div className="widget-chart widget-chart-hover br-br">
              <div className="icon-wrapper rounded-circle">
                <div className="icon-wrapper-bg bg-success" />
                <i className="lnr-pencil text-success" />
              </div>
              <div className="widget-numbers">
                {totals && totals.riun}
              </div>
              <div className="widget-subheading">
                {Strings('total_users')}
              </div>
            </div>
          </Card>
        </Col>

      </Row>

      <Row className="mt-5">
        <Col>
          <ReactTable
            minRows={0}
            data={its}
            columns={tableColumns}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </Col>
      </Row>
    </CardBody>
  );
}
